"use strict";

const DataViewConfig = function () {
  const get = function () {
    // Tests fail if these are imported at the bottom
    const BmpFcsToDoController = require("../bmpfcs/bmpFcsToDoController");
    const IncidentsGeoServerLayer = require("../illicitDischarge/incidents/incidentsGeoServerLayer");
    const ResourceController = require("../offline/resourceController");
    const HardAssetInspectionGate = require("../muni/hardAssetInspectionGate");
    const ConstructionFilters = require("../construction/constructionFilters");
    const IndcomFacilityFilters = require("../indcom/indcomFacilityFilters");
    const ScenarioFilter = require("../filters/scenarioFilter");
    const PageController = require("../esg/pageController");
    const LidToDoList = require("../lid/lidToDoList");
    const ConstructionProjectG2Filters = require("../constructionG2/constructionProjectG2Filters");
    const StreetSweepingLayer = require("../muni/streetSweepingLayer");
    const BmpFilter = require("../filters/bmpFilter");
    const VaFilter = require("../filters/vaFilter");
    const MuniCatchBasinFilters = require("../muni/muniCatchBasinFilters");
    const PostConstructionProjectG2Filters = require("../constructionG2/postConstructionProjectG2Filters");
    const MuniOutfallsFilters = require("../muni/outfalls/muniOutfallsFilters");
    const MuniBmpFilters = require("../muni/bmp/muniBmpFilters");
    const LidBmpFilters = require("../lid/lidBmpFilters");
    const StructuralBmpFilters = require("../bmpFcsG2/structuralBmpFilters");
    const MuniCleanoutFilters = require("../muni/muniCleanoutFilters");
    const MuniManholeFilters = require("../muni/muniManholeFilters");
    const MuniLiftStationsFilters = require("../muni/muniLiftStationsFilters");
    const MuniOpenChannelFilters = require("../muni/openChannel/muniOpenChannelFilters");
    const MuniPipesFilters = require("../muni/muniPipesFilters");
    const MuniCulvertFilters = require("../muni/culvert/muniCulvertFilters");
    const IncidentsFilters = require("../illicitDischarge/incidents/incidentsFilters");
    const MonitoringLocationFilters = require("../illicitDischarge/monitoringLocationFilters");
    const OtherPropertiesLayer = require("../esg/properties/otherPropertiesLayer");
    const ActivityFilters = require("../peo/activityFilters");
    const AssetManagementFilters = require("../assetManagement/filters/assetManagementFilters");
    const SamplingSiteFilters = require("../wq/samplingSiteFilters");
    const Actions = require("../actions");
    const FilterFieldConstants = require("./filterFieldConstants");
    const Progeny = require("../login/progeny");

    const defaultStormDrainLayer = ToolSettings.getSetting("simplifiedStormdrainLayer")
      ? "stormdrainGeoServer"
      : "stormdrains";

    const isHardAssetViewOffline = (assetType, layerKey) =>
      HardAssetInspectionGate.isOfflineEnabledForAssetType(assetType) &&
      ResourceController.get(layerKey).getOfflineCount() > 0;

    return {
      "muni-lift-stations": {
        factSheetRouteName: "lift-station-fact-sheet",
        isGisDataView: true,
        name: "Lift Stations",
        dataSortByTab: { data: ["muniLiftStationsId", "address"] },
        defaultLayers: ["muniLiftStations"],
        flatDataSort: "muniLiftStationsId",
        actionButtons: [],
        filterModule: MuniLiftStationsFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "implementerType",
          "maintainedBy",
          "landOwnership",
          "phase",
          "condition",
          "consequenceOfFailure",
          "correctiveAction",
          "enforcementLevel",
          "liftStationType",
          "routineDate",
          "repairDate",
          "installDate",
        ],
        listActionButtonHide: true,
        hideMapListToggle: { data: false },
        searchPlaceholder: "Search by ID or Street Address",
        searchByPropertyEnabled: true,
        topLevelDataSort: ["rw", "maintenanceZones"],
        defaultTab: "data",
        mapEnabledTabs: ["data"],
        listEnabledTabs: ["data"],
        defaultImportLayer: "lift-stations",
        setToMapView: true,
        offline: isHardAssetViewOffline("liftStation", "muniLiftStations"),
      },
      bmp: {
        factSheetRouteName: "sbmp-fact-sheet",
        isGisDataView: Tree.get("activeTab") === "data" ? true : false,
        name: "Structural BMPs",
        defaultLayers: Tree.get("activeTab") === "data" ? ["structuralBmps"] : ["bmps"],
        searchByPropertyEnabled: true,
        listEnabledTabs: ["todo", "data", "insight"],
        mapEnabledTabs: ["data", "todo"],
        topLevelDataSort: ["rw", "ud", "uc"],
        flatDataSort: "bmpName",
        dataSortByTab: { data: ["bmpName", "bmpTotal", "bmpImp", "bmpType", "bmpStatus"] },
        toDoSubjects: ["assessmentDue", "maintenanceNeeded", "inventoryIncomplete"],
        actionButtons: [
          {
            offline: false,
            buttonText: "Add New sBMP",
            dataAction: "add-new",
            permissionKey: "can_create_bmps",
          },
        ],
        showActionButtonsTabs: ["data", "todo"],
        searchPlaceholder: "Search ID, address, or facility name",
        hideMapListToggle: { data: false },
        defaultTab: "data",
        defaultImportLayer: "sbmps",
        reportingDataGroup: "stormwater group",
        exportsEnabled: ["excel", "shapefile"],
        defaultExportType: "excel",
        activeTabChangeCallback: BmpFcsToDoController.handleConditionPhaseToggleDisplay,
        filterModule: StructuralBmpFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "phase",
          "sbmpCategory",
          "types",
          "implementerType",
          "responsiblePartyMaintenance",
          "systemAccess",
          "fcs",
          "installDate",
          "assessmentDate",
          "score",
          "bmpCondition",
          "consequenceOfFailure",
          "inProximityTo303dWaterbody",
          "bmpFlow",
          "drainsout",
          "diversion",
        ],
      },
      va: {
        name: "Trash Assessment",
        defaultLayers: ["trashLines"],
        defaultDisabledLayers: [
          "landuse",
          "fullDrainageFcs",
          "fullDrainageBmp",
          "projects",
          "bmpFcs",
          "bmps",
          "fcs",
        ],
        setToMapView: true,
        flatDataSort: "uc",
        actionButtons: [
          {
            offline: false,
            buttonText: "Add New FCS",
            dataAction: "add-new",
            permissionKey: "can_create_bmps",
          },
        ],
        topLevelDataSort: ["rw", "ud", "uc"],
        searchPlaceholder: "Search catchments",
        filterBarHiddenButtons: ["item-count"],
        defaultTab: "data",
        listEnabledTabs: [],
        mapEnabledTabs: ["data"],
        reportingDataGroup: "trash group",
        hideMapListToggle: { data: true },
        filterModule: VaFilter,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "vaCondition",
          "assessmentDate",
          "photos",
        ],
        hasAssociatedG2Layer: true,
        useSimpleOutfallG2Layer: true,
      },
      fcs: {
        name: "Full Capture System",
        defaultLayers: ["fcs"],
        defaultDisabledLayers: [
          "bmps",
          "trashLines",
          "priority",
          "landuse",
          "fullDrainageFcs",
          "fullDrainageBmp",
          "projects",
        ],
        setToMapView: true,
        flatDataSort: "fcsId",
        searchByPropertyEnabled: true,
        listEnabledTabs: ["todo", "data"],
        mapEnabledTabs: ["data", "todo"],
        topLevelDataSort: ["rw", "uc", "ud"],
        dataSortByTab: { data: ["fcsId", "fcsTotal", "fcsPlu", "fcsType", "fcsStatus"] },
        toDoSubjects: ["assessmentDue", "maintenanceNeeded", "inventoryIncomplete"],
        actionButtons: [
          {
            offline: false,
            buttonText: "Add New FCS",
            dataAction: "add-new",
            permissionKey: "can_create_bmps",
          },
        ],
        searchPlaceholder: "Search ID, address, or facility name",
        defaultTab: "data",
        reportingDataGroup: "trash group",
        exportsEnabled: ["excel", "shapefile"],
        defaultExportType: "excel",
        hideMapListToggle: { data: false },
        filterModule: BmpFilter,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "phase",
          "score",
          "fcsType",
          "assessmentDate",
          "installDate",
          "ownership",
        ],
        hasAssociatedG2Layer: true,
        useSimpleOutfallG2Layer: true,
      },
      "construction-project": {
        factSheetRouteName: "construction-project-fact-sheet",
        isGisDataView: Tree.get("activeTab") === "data",
        hasAssociatedG2Layer: true,
        name: "Compliance",
        enableFilterSummaryOnMapOrListToggle: true,
        offline: ResourceController.get("constructionProjectG2").getOfflineCount() > 0,
        defaultLayers: ["constructionProjectG2"],
        flatDataSort: "projectIdentifier",
        searchByPropertyEnabled: true,
        listEnabledTabs: ["data", "todo", "insight"],
        mapEnabledTabs: ["data"],
        topLevelDataSort: ["rw", "ud", "uc", "highways"],
        dataSortByTab: {
          data: ["projectIdentifier", "projectName", "projectAddressG2", "priority"],
        },
        hideMapListToggle: { todo: true, insight: true },
        toDoSubjects: [
          "constructionProjectRoutineInspection",
          "constructionProjectReInspection",
          "constructionProjectMaintenanceResponse",
          "constructionProjectFlaggedForNewEnforcement",
          "constructionProjectOpenEnforcement",
          "constructionProjectFlaggedForEnforcementRecommendedAction",
          "constructionInstallationInspection",
          "constructionCompleteProject",
        ],
        actionButtons: [
          {
            offline: false,
            buttonText: "Add New Project",
            dataAction: "add-new",
            permissionKey: "can_create_projects",
          },
        ],
        showActionButtonsTabs: ["data", "todo"],
        searchPlaceholder: "Search project ID, name, or address",
        defaultTab: "data",
        defaultImportLayer: "projects",
        reportingDataGroup: "construction",
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
        smartToDoFilters: true,
        filterModule: ConstructionProjectG2Filters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "phase",
          "inspectionDate",
          "startDate",
          "completedDate",
          "constructionOwnership",
          "maintainerType",
          "priority",
          "paused",
          "openEnforcements",
        ],
      },
      "construction-project-delivery": {
        factSheetRouteName: "construction-project-delivery-fact-sheet",
        name: "Project Delivery",
        defaultLayers: ["constructionProject"],
        flatDataSort: "projectIdentifier",
        searchByPropertyEnabled: true,
        listEnabledTabs: ["data"],
        mapEnabledTabs: ["data"],
        hasAssociatedG2Layer: true,
        topLevelDataSort: ["rw", "ud", "uc"],
        enableFilterSummaryOnMapOrListToggle: true,
        dataSortByTab: { data: ["projectIdentifier", "projectName", "projectAddress", "status"] },
        actionButtons: [
          {
            offline: false,
            buttonText: "Add New Project",
            dataAction: "add-new",
            permissionKey: "can_create_projects",
          },
        ],
        searchPlaceholder: "Search project ID, name, or address",
        defaultTab: "data",
        defaultImportLayer: "projects",
        reportingDataGroup: "construction",
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
        filterModule: ConstructionFilters,
        mapSummaryTableEnabledTabs: ["data"],
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "phase",
          "implementerType",
          "maintainerType",
          "landOwnership",
          "associatedBmpTypes",
          "projectType",
          "developmentType",
        ],
      },
      "lid-project": {
        factSheetRouteName: "lid-fact-sheet",
        name: "PCR Project",
        isGisDataView: true,
        hasAssociatedG2Layer: true,
        defaultLayers: ["postConstructionProjectG2"],
        defaultDisabledLayers: ["lidProjectBmp", "runoffCondition"],
        flatDataSort: "lidProjectId",
        searchByPropertyEnabled: true,
        topLevelDataSort: ["rw", "ud", "uc"],
        dataSortByTab: { data: ["lidProjectId", "lidProjectStatus", "lidProjectPerformanceG2"] },
        actionButtons: [
          {
            offline: false,
            buttonText: "Add New Project",
            dataAction: "add-new",
            permissionKey: "can_create_projects",
          },
        ],
        showActionButtonsTabs: ["data", "todo"],
        setToMapView: true,
        searchPlaceholder: "Search project ID, name, or address",
        defaultTab: "data",
        listEnabledTabs: ["data", "todo", "insight"],
        mapEnabledTabs: ["data", "todo"],
        defaultImportLayer: "projects",
        reportingDataGroup: "lid",
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
        filterModule: PostConstructionProjectG2Filters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "status",
          "performanceTier",
          "lidOwnership",
          "maintainerType",
          "completed",
          "noticeSentDate",
          "initialMaintenanceNotice",
          "initialRoutineInspection",
          "alternativeCompliance",
          "openEnforcements",
        ],
        toDoSubjects: [
          "lidMaintenanceNotice",
          "lidInspection",
          "lidReInspection",
          "lidMaintenanceResponse",
          "lidReviewResponse",
          "lidProjectFlaggedForNewEnforcement",
          "lidProjectEnforcement",
          "lidProjectRecommendedAction",
          "lidMissingInformation",
        ],
        activeTabChangeCallback: LidToDoList.handleConditionPhaseToggleDisplay,
        limitedAccessDisabledDataViews: ["lid-runoff"],
        smartToDoFilters: true,
      },
      "lid-bmp": {
        factSheetRouteName: "lid-bmp-fact-sheet",
        isGisDataView: true,
        name: "Structural BMPs",
        defaultLayers: ["lidBmp"],
        actionButtons: UserPermissions.getPermission("can_create_bmps")
          ? [
              {
                offline: false,
                buttonText: "Add New sBMP",
                dataAction: "add-new",
                permissionKey: "can_create_bmps",
              },
            ]
          : [],
        showActionButtonsTabs: ["data", "todo"],
        searchPlaceholder: "Search by ID or Street Address",
        searchByPropertyEnabled: true,
        topLevelDataSort: ["rw", "maintenanceZones"],
        flatDataSort: "muniBmpId",
        dataSortByTab: { data: ["muniBmpId", "address"] },
        defaultTab: "data",
        mapEnabledTabs: ["todo", "data"],
        listEnabledTabs: ["todo", "data", "insight"],
        toDoSubjects: ["lidRoutineSiteVisitBmp", "lidReInspectionBmp"],
        defaultImportLayer: "sbmps",
        setToMapView: true,
        hideMapListToggle: { data: false },
        filterModule: LidBmpFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "implementerType",
          "responsiblePartyMaintenance",
          "types",
          "implementationPhase",
          "condition",
          "consequenceOfFailure",
          "correctiveAction",
          "enforcementLevel",
          "fcs",
          "inProximityTo303dWaterbody",
          "projectAssociation",
          "routineDate",
          "repairDate",
          "installDate",
        ],
        smartToDoFilters: true,
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
      },
      "lid-runoff": {
        name: "Runoff Condition",
        isGisDataView: true,
        defaultLayers: ["runoffCondition"],
        defaultDisabledLayers: ["lidProjectArea", "lidProjectBmp"],
        catchmentView: true,
        catchmentViewDefaultEnabledLayers: ["runoffCondition"],
        catchmentViewDefaultDataSort: "apn",
        topLevelDataSort: ["rw", "ud", "uc"],
        dataSortByTab: { data: ["apn"] },
        flatDataSort: "apn",
        searchByPropertyEnabled: true,
        actionButtons: [],
        hideMapListToggle: { data: true },
        searchPlaceholder: "Search address or APN",
        filterBarDisabledButtons: [],
        filterBarHiddenButtons: ["search", "filter"],
        defaultTab: "data",
        listEnabledTabs: [],
        mapEnabledTabs: ["data"],
        defaultImportLayer: "projects",
        reportingDataGroup: "stormwater group",
      },
      "indcom-facilities": {
        factSheetRouteName: "facility-fact-sheet",
        isGisDataView: true,
        name: "Industrial/Commercial",
        defaultLayers: ["indcomFacilities"],
        searchByPropertyEnabled: true,
        enableFilterSummaryOnMapOrListToggle: true,
        actionButtons: [
          {
            offline: false,
            buttonText: "Add New Facility",
            dataAction: "add-new",
            permissionKey: "can_create_facility",
          },
        ],
        showActionButtonsTabs: ["data", "todo"],
        filterBarDisabledButtons: [],
        topLevelDataSort: ["rw", "ud", "uc"],
        flatDataSort: "indcomFacilitiesName",
        searchPlaceholder: "Search facility ID, name, or address",
        dataSortByTab: { data: ["indcomFacilitiesName", "facilityIdentifier"] },
        defaultTab: "data",
        listEnabledTabs: ["data", "todo", "insight"],
        mapEnabledTabs: ["data", "todo"],
        toDoSubjects: [
          "indcomFacilityInspection",
          "indcomFacilityReinspection",
          "indcomFacilityMaintenanceResponse",
          "indcomFacilityReviewResponse",
          "indcomFacilityFlaggedForNewEnforcement",
          "indcomFacilityEnforcement",
          "indcomFacilityRecommendedAction",
          "indcomFacilityInventoryIncomplete",
        ],
        defaultImportLayer: "facilities",
        reportingDataGroup: "indcom",
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
        hideMapListToggle: { insight: true },
        filterModule: IndcomFacilityFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "facilityType",
          "facilityPhase",
          "inspection",
          "openFindings",
          "facilityOpenEnforcements",
          "responsiblePartyManagement",
          "fogParticipant",
          "isIndustrialGeneralPermit",
          "mobileBusiness",
          "riskProfile",
        ],
        smartToDoFilters: true,
        offline: ResourceController.get("indcomFacilities").getOfflineCount() > 0,
      },
      "dry-weather": {
        factSheetRouteName: "idde-fact-sheet",
        isGisDataView: true,
        name: "Dry Weather",
        defaultLayers: ["monitoringLocation"],
        actionButtons: [],
        setToMapView: true,
        hideMapListToggle: { data: true },
        filterBarDisabledButtons: [],
        filterBarHiddenButtons: [],
        filterModule: MonitoringLocationFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "assetType",
          "isMonitoringLocation",
          "flowCondition",
          "collectSamples",
          "illicitDischarge",
          "waterQualityExceedances",
          "iddeScreeningDate",
          "cof",
        ],
        topLevelDataSort: ["rw", "ud", "uc"],
        dataSortByTab: { data: ["monitoringLocationId"] },
        flatDataSort: "monitoringLocationId",
        searchPlaceholder: "Search monitoring location name",
        searchByPropertyEnabled: true,
        defaultTab: "data",
        toDoSubjects: ["routineScreeningDryWeather", "reScreeningDryWeather"],
        listEnabledTabs: ["todo"],
        hasAssociatedG2Layer: true,
        mapEnabledTabs: ["data", "todo"],
        defaultImportLayer: "outfalls",
        reportingDataGroup: "idde",
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
        smartToDoFilters: true,
      },
      outfalls: {
        factSheetRouteName: "outfalls-fact-sheet",
        name: "Outfalls",
        defaultLayers: ["outfalls"],
        defaultModalLayers: [defaultStormDrainLayer],
        actionButtons: [
          {
            offline: false,
            disabled: false,
            buttonText: "Add New Outfall",
            dataAction: "add-new",
            permissionKey: "can_create_outfall",
          },
        ],
        hideMapListToggle: { data: true },
        filterBarDisabledButtons: ["filter"],
        filterBarHiddenButtons: ["filter"],
        topLevelDataSort: ["rw", "ud", "uc", "maintenanceZones"],
        dataSortByTab: { data: ["outfallsId"] },
        flatDataSort: "outfallsId",
        searchPlaceholder: "Search outfall name",
        searchByPropertyEnabled: true,
        defaultTab: "data",
        mapEnabledTabs: ["data"],
        listEnabledTabs: [],
        defaultImportLayer: "outfalls",
        reportingDataGroup: "muni outfall",
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
        esriLayer: "catch-basin", // @TODO: Update for outfall esri layer
        hasAssociatedG2Layer: true,
      },
      "sampling-site": {
        isGisDataView: true,
        name: "Sampling Sites",
        defaultLayers: ["samplingSites"],
        defaultModalLayers: [defaultStormDrainLayer],
        actionButtons: [
          {
            offline: false,
            buttonText: "Add New Sampling Site",
            dataAction: "add-new",
            permissionKey: "can_create_sampling_site",
          },
        ],
        hideMapListToggle: { data: true },
        filterModule: SamplingSiteFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "maintainedBy",
          "sitePhase",
          "siteType",
        ],
        filterBarDisabledButtons: ["filter"],
        filterBarHiddenButtons: ["filter"],
        topLevelDataSort: ["rw", "ud", "uc"],
        dataSortByTab: { data: ["siteIdentifier"] },
        flatDataSort: "siteIdentifier",
        searchPlaceholder: "Search by ID or Street Address",
        searchByPropertyEnabled: true,
        defaultTab: "data",
        mapEnabledTabs: ["data"],
        listEnabledTabs: [],
        defaultImportLayer: "samplingSites",
        reportingDataGroup: "water quality",
        exportsEnabled: null,
        defaultExportType: "excel",
      },
      "wq-monitoring": {
        factSheetRouteName: "wq-monitoring-fact-sheet",
        isGisDataView: true,
        name: "WQ Monitoring",
        defaultLayers: ["wqMonitoringLocations"],
        actionButtons: [],
        setToMapView: true,
        hideMapListToggle: { data: true },
        filterBarDisabledButtons: ["filter"],
        filterBarHiddenButtons: ["filter"],
        topLevelDataSort: ["rw", "ud", "uc"],
        dataSortByTab: { data: ["wqMonitoringLocationId"] },
        flatDataSort: "wqMonitoringLocationId",
        searchPlaceholder: "Search monitoring location ID",
        searchByPropertyEnabled: true,
        defaultTab: "data",
        hasAssociatedG2Layer: true,
        mapEnabledTabs: ["data"],
        listEnabledTabs: [],
        defaultImportLayer: "samplingSites",
        reportingDataGroup: "water quality",
      },
      "asset-management": {
        name: "asset Management",
        defaultLayers: Actions.useCachedLayers(["assetsPipeEsriDynamicMap"]),
        actionButtons: [],
        flatDataSort: "assetManagementId",
        dataSortByTab: { data: ["assetManagementId"] },
        filterBarHiddenButtons: ["item-count", "search"],
        filterBarDisabledButtons: ["search"],
        topLevelDataSort: ["rw", "ud", "uc", "highways"],
        searchPlaceholder: "Search outfall name",
        searchByPropertyEnabled: true,
        defaultTab: "data",
        mapEnabledTabs: ["data"],
        listEnabledTabs: [],
        mapSummaryTableEnabledTabs: ["data"],
        widgetScreenButton: true,
        reportingDataGroup: "muni outfall",
        defaultExportType: "excel",
        esriKey: "assets",
        esriLayer: "pipe", // @TODO: Update for outfall esri layer
        filterModule: AssetManagementFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "attributionStatus",
          "material",
          "size",
          "probabilityOfFailure",
          "consequenceOfFailure",
          "criticality",
          "phase",
          "responsiblePartyMaintenance",
          "installDateNoDate",
        ],
      },
      "muni-outfalls": {
        factSheetRouteName: "outfall-fact-sheet",
        name: "Outfalls",
        defaultLayers: ["muniOutfalls"],
        defaultModalLayers: [defaultStormDrainLayer],
        setToMapView: true,
        actionButtons: [
          {
            offline: false,
            disabled: false,
            buttonText: "Add New Outfall",
            dataAction: "add-new",
            permissionKey: "can_create_outfall",
          },
        ],
        topLevelDataSort: ["rw", "ud", "uc", "maintenanceZones", "highways"],
        dataSortByTab: { data: ["outfallsId", "address"] },
        flatDataSort: "outfallsId",
        searchPlaceholder: "Search by ID or Street Address",
        searchByPropertyEnabled: true,
        defaultTab: "data",
        mapEnabledTabs: ["data", "todo"],
        toDoSubjects: ["muniOutfallRoutineInspection", "muniOutfallRoutineMaintenance"],
        listEnabledTabs: ["data", "todo", "insight"],
        showActionButtonsTabs: ["data", "todo"],
        defaultImportLayer: "outfalls",
        reportingDataGroup: "muni outfall",
        exportsEnabled: ["excel", "shapefile"],
        defaultExportType: "excel",
        isGisDataView: true,
        offline: ResourceController.get("muniOutfalls").getOfflineCount() > 0,
        filterModule: MuniOutfallsFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "implementerType",
          "responsiblePartyMaintenance",
          "landOwnership",
          "outfallType",
          "outletType",
          "implementationPhase",
          "condition",
          "cof",
          "correctiveAction",
          "enforcementLevel",
          "outletShape",
          "diameterRange",
          "lengthRange",
          "widthRange",
          "routineDate",
          "repairDate",
          "installDate",
        ],
        smartToDoFilters: true,
      },
      scenarios: {
        name: "Scenario Planning",
        defaultTab: "insight",
        mapEnabledTabs: ["result"],
        topLevelDataSort: ["rw", "ud", "uc"],
        hideMapListToggle: { data: true, insight: true, result: true },
        listEnabledTabs: ["data", "insight"],
        defaultLayers: ["scenarios", "telrResult"],
        hasAssociatedG2Layer: true,
        searchByPropertyEnabled: true,
        searchPlaceholder: "Search asset ID",
        dataSortByTab: {
          data: [
            "scenarioAssetId",
            "drainageArea",
            "imperviousAreaTreated",
            "typeAbbreviation",
            "bmpPhase",
          ],
        },
        flatDataSort: "scenarioAssetId",
        actionButtons: UserPermissions.getPermission("can_run_telr")
          ? [
              {
                offline: false,
                buttonText: "Run TELR",
                dataAction: "run-telr-scenario",
                disabled: false,
                permissionKey: "can_run_telr",
              },
            ]
          : [],
        showActionButtonsTabs: ["insight"],
        filterModule: ScenarioFilter,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "scenario",
          "phase",
          "sbmpCategory",
          "types",
          "analysisReady",
        ],
        scenarioDropdown: [
          { value: "baseline-runoff", name: "Runoff - Baseline" },
          { value: "current-runoff", name: "Runoff - Current" },
          { value: "potential-runoff", name: "Runoff - Potential" },
          { value: "divider", name: "" },
          { value: "baseline-particulate", name: "Particulates - Baseline" },
          { value: "current-particulate", name: "Particulates - Current" },
          { value: "potential-particulate", name: "Particulates - Potential" },
        ],
        mapSummaryTableEnabledTabs: ["result"],
      },
      incidents: {
        name: "Incidents",
        factSheetRouteName: "incident-fact-sheet",
        isGisDataView: true,
        actionButtons: [
          {
            offline: false,
            disabled: false,
            buttonText: "Add New Incident",
            dataAction: "add-new",
            permissionKey: "can_create_incident",
          },
        ],
        showActionButtonsTabs: ["data", "todo"],
        setToMapView: true,
        hideMapListToggle: { data: true, todo: false, insight: true, result: true },
        filterBarDisabledButtons: [],
        searchPlaceholder: "Search by Incident ID",
        flatDataSort: "incidentName",
        searchByPropertyEnabled: true,
        dataSortByTab: { data: ["incidentName"] },
        defaultLayers: ["incidents"],
        defaultTab: "data",
        topLevelDataSort: ["rw", "ud", "uc", "highways"],
        mapEnabledTabs: ["data", "todo"],
        toDoSubjects: [
          "incidentNew",
          "incidentOpen",
          "incidentReinvestigation",
          "incidentMaintenanceResponse",
          "incidentFlaggedForNewEnforcement",
          "incidentOpenEnforcement",
          "incidentRecommendedAction",
        ],
        listEnabledTabs: ["todo", "insight"],
        reportingDataGroup: "idde",
        exportsEnabled: ["excel", "csv"],
        defaultExportType: "excel",
        activeTabChangeCallback: IncidentsGeoServerLayer.updateLegendByActiveTab,
        filterModule: IncidentsFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "incidentStatus",
          "incidentType",
          "activityType",
          "closeOutReason",
          "requestedDate",
          "openEnforcements",
        ],
        hasAssociatedG2Layer: true,
        smartToDoFilters: true,
      },
      muniCatchBasinView: { isGisDataView: true, liveDataView: "muni_catch_basins" },
      "muni-catch-basin": {
        factSheetRouteName: "catch-basin-fact-sheet",
        isGisDataView: true,
        offline: ResourceController.get("muniCatchBasin").getOfflineCount() > 0,
        name: "Catch Basins",
        defaultLayers: ["muniCatchBasin"],
        defaultModalLayers: [defaultStormDrainLayer],
        setToMapView: true,
        flatDataSort: "muniCatchBasinId",
        searchByPropertyEnabled: true,
        topLevelDataSort: ["rw", "ud", "uc", "maintenanceZones"],
        toDoSubjects: ["routineSiteVisit", "routineRepair", "catchBasinInventoryIncomplete"],
        dataSortByTab: { data: ["muniCatchBasinId", "address"] },

        actionButtons: [
          {
            buttonText: "Add New",
            dataAction: "add-new",
            permissionKey: "can_create_bmps",
            offline: false,
          },
          {
            buttonText: "Bulk Clean",
            dataAction: "bulk-clean",
            permissionKey: "can_inspect_bmps",
            offline: false,
          },
        ],
        searchPlaceholder: "Search by ID or Street Address",
        showActionButtonsTabs: ["data", "todo"],
        defaultTab: "data",
        mapEnabledTabs: ["data", "todo"],
        listEnabledTabs: ["data", "todo", "insight"],
        defaultImportLayer: "catchBasins",
        reportingDataGroup: "muni catch basin",
        esriLayer: "catch-basin",
        filterModule: MuniCatchBasinFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "implementerType",
          "responsiblePartyMaintenance",
          "catchBasinType",
          "phase",
          "condition",
          "consequenceOfFailure",
          "correctiveAction",
          "enforcementLevel",
          "fcs",
          "inProximityTo303dWaterbody",
          "lastDate",
          "cleanDate",
          "routineDate",
          "repairDate",
          "installDate",
        ],
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
        smartToDoFilters: true,
      },
      "muni-cleanout": {
        factSheetRouteName: "cleanout-fact-sheet",
        isGisDataView: true,
        name: "Cleanouts",
        defaultLayers: ["muniCleanout"],
        actionButtons: [],
        filterModule: MuniCleanoutFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "implementerType",
          "maintainedBy",
          "landOwnership",
          "cleanoutType",
          "phase",
          "condition",
          "consequenceOfFailure",
          "correctiveAction",
          "enforcementLevel",
          "shape",
          "diameterRange",
          "lengthRange",
          "widthRange",
          "routineDate",
          "repairDate",
          "installDate",
        ],
        searchPlaceholder: "Search by ID or Street Address",
        searchByPropertyEnabled: true,
        topLevelDataSort: ["rw", "maintenanceZones"],
        flatDataSort: "muniCleanoutId",
        dataSortByTab: { data: ["muniCleanoutId", "address"] },
        defaultTab: "data",
        hideMapListToggle: { data: false },
        mapEnabledTabs: ["data"],
        listEnabledTabs: ["data"],
        defaultImportLayer: "cleanouts",
        setToMapView: true,
        offline: isHardAssetViewOffline("cleanout", "muniCleanout"),
        listActionButtonHide: true,
      },
      roads: {
        name: "Street Sweeping",
        hasAssociatedG2Layer: true,
        defaultLayers: ToolSettings.getSetting("group", "dataDrivenRoadCondition")
          ? ["streetSweepingRoutePriority"]
          : ["roadPriority"],
        actionButtons: [
          {
            offline: false,
            buttonText: "Add Sweeps",
            dataAction: "bulk-record-sweep",
            permissionKey: "can_create_record_sweeps",
          },
          {
            offline: false,
            buttonText: "Route Plan",
            dataAction: "road-om",
            permissionKey: "can_edit_roads",
            disabled: Session.isDisabledRouteOmGroup(),
          },
        ],
        catchWithRoadCondition: true,
        filterBarDisabledButtons: [],
        topLevelDataSort: ToolSettings.getSetting("group", "dataDrivenRoadCondition")
          ? ["sweepingNetworks"]
          : ["rw", "ud", "uc", "maintenanceZones"],
        getTopLevelDataSortCallback: ToolSettings.getSetting("group", "dataDrivenRoadCondition")
          ? StreetSweepingLayer.getTopLevelDataSort
          : null,
        flatDataSort: "uc",
        searchPlaceholder: "Search by ID or Street Address",
        defaultTab: "data",
        filterBarHiddenButtons: ["search", "filter", "item-count"],
        hideMapListToggle: { data: true },
        mapEnabledTabs: ["data"],
        listEnabledTabs: ["insight"],
        showActionButtonsTabs: ["data"],
        reportingDataGroup: "stormwater group",
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
        esriLayer: ToolSettings.getSetting("group", "dataDrivenRoadCondition")
          ? "streetSweepingRoutePriority"
          : "roadPriority",
        esriKey: ToolSettings.getSetting("group", "dataDrivenRoadCondition")
          ? "streetSweepingRoute"
          : "roadsOm",
        setToMapView: true,
        useSimpleOutfallG2Layer: true,
      },
      "muni-manhole": {
        factSheetRouteName: "manhole-fact-sheet",
        isGisDataView: true,
        name: "Manholes",
        defaultLayers: ["muniManhole"],
        actionButtons: [],
        listActionButtonHide: true,
        searchPlaceholder: "Search by ID or Street Address",
        searchByPropertyEnabled: true,
        topLevelDataSort: ["rw", "ud", "uc", "maintenanceZones"],
        flatDataSort: "muniManholeId",
        dataSortByTab: { data: ["muniManholeId", "address"] },
        defaultTab: "data",
        hideMapListToggle: { data: false },
        mapEnabledTabs: ["data"],
        listEnabledTabs: ["data"],
        defaultImportLayer: "manholes",
        setToMapView: true,
        offline: isHardAssetViewOffline("manhole", "muniManhole"),
        filterModule: MuniManholeFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "implementerType",
          "responsiblePartyMaintenance",
          "landOwnership",
          "manholeType",
          "implementationPhase",
          "cof",
          "correctiveAction",
          "enforcementLevel",
          "shape",
          "diameterRange",
          "lengthRange",
          "widthRange",
          "routineDate",
          "repairDate",
          "installDate",
        ],
      },
      "muni-bmp": {
        factSheetRouteName: "muni-bmp-fact-sheet",
        isGisDataView: true,
        offline: isHardAssetViewOffline("bmpFcs", "muniBmp"),
        name: "Structural BMPs",
        defaultLayers: ["muniBmp"],
        actionButtons: UserPermissions.getPermission("can_create_bmps")
          ? [
              {
                offline: false,
                buttonText: "Add New sBMP",
                dataAction: "add-new",
                permissionKey: "can_create_bmps",
              },
            ]
          : [],
        showActionButtonsTabs: ["data", "todo"],
        searchPlaceholder: "Search by ID or Street Address",
        searchByPropertyEnabled: true,
        topLevelDataSort: ["rw", "maintenanceZones"],
        flatDataSort: "muniBmpId",
        dataSortByTab: { data: ["muniBmpId", "address"] },
        defaultTab: "data",
        mapEnabledTabs: ["todo", "data"],
        listEnabledTabs: ["todo", "data", "insight"],
        toDoSubjects: ["routineSiteVisitBmp", "routineRepairBmp"],
        defaultImportLayer: "sbmps",
        setToMapView: true,
        hideMapListToggle: { data: false },
        filterModule: MuniBmpFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "implementerType",
          "responsiblePartyMaintenance",
          "types",
          "implementationPhase",
          "condition",
          "consequenceOfFailure",
          "correctiveAction",
          "enforcementLevel",
          "fcs",
          "inProximityTo303dWaterbody",
          "routineDate",
          "repairDate",
          "installDate",
        ],
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
        reportingDataGroup: "muni bmp",
        smartToDoFilters: true,
      },
      "muni-culvert": {
        factSheetRouteName: "culvert-fact-sheet",
        isGisDataView: true,
        name: "Culverts",
        defaultLayers: ["muniCulvert"],
        actionButtons: [],
        listActionButtonHide: true,
        searchPlaceholder: "Search by ID",
        searchByPropertyEnabled: true,
        topLevelDataSort: ["rw", "maintenanceZones"],
        flatDataSort: "muniCulvertId",
        dataSortByTab: { data: ["muniCulvertId"] },
        defaultTab: "data",
        hideMapListToggle: { data: false },
        mapEnabledTabs: ["data"],
        listEnabledTabs: ["data"],
        defaultImportLayer: "culverts",
        setToMapView: true,
        offline: isHardAssetViewOffline("culvert", "muniCulvert"),
        filterModule: MuniCulvertFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "implementerType",
          "responsiblePartyMaintenance",
          "landOwnership",
          "culvertType",
          "implementationPhase",
          "serviceType",
          "accessible",
          "condition",
          "cof",
          "correctiveAction",
          "enforcementLevel",
          "linedAssetsShapes",
          "diameterRange",
          "lengthRange",
          "widthRange",
          "lined",
          "routineDate",
          "repairDate",
          "installDate",
        ],
      },
      "muni-open-channel": {
        factSheetRouteName: "open-channel-fact-sheet",
        isGisDataView: true,
        name: "Open Channels",
        defaultLayers: ["muniOpenChannel"],
        actionButtons: [],
        listActionButtonHide: true,
        searchPlaceholder: "Search by ID",
        searchByPropertyEnabled: true,
        topLevelDataSort: ["rw", "maintenanceZones"],
        flatDataSort: "muniOpenChannelId",
        dataSortByTab: { data: ["muniOpenChannelId"] },
        defaultTab: "data",
        hideMapListToggle: { data: false },
        mapEnabledTabs: ["data"],
        listEnabledTabs: ["data"],
        defaultImportLayer: "open-channels",
        setToMapView: true,
        offline: isHardAssetViewOffline("openChannel", "muniOpenChannel"),
        filterModule: MuniOpenChannelFilters,
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "implementerType",
          "responsiblePartyMaintenance",
          "landOwnership",
          "openChannelType",
          "serviceType",
          "flowType",
          "condition",
          "implementationPhase",
          "accessible",
          "cof",
          "correctiveAction",
          "enforcementLevel",
          "linedAssetsShapes",
          "lengthRange",
          "widthRange",
          "lined",
          "routineDate",
          "repairDate",
          "installDate",
        ],
      },
      "muni-pipes": {
        factSheetRouteName: "pipe-fact-sheet",
        isGisDataView: true,
        name: "Pipes",
        defaultLayers: ["muniPipes"],
        actionButtons: [],
        listActionButtonHide: true,
        filterModule: MuniPipesFilters,
        searchPlaceholder: "Search by ID",
        searchByPropertyEnabled: true,
        topLevelDataSort: ["rw", "maintenanceZones"],
        flatDataSort: "muniPipesId",
        dataSortByTab: { data: ["muniPipesId"] },
        defaultTab: "data",
        hideMapListToggle: { data: false },
        mapEnabledTabs: ["data"],
        listEnabledTabs: ["data"],
        defaultImportLayer: "pipes",
        setToMapView: true,
        offline: isHardAssetViewOffline("pipe", "muniPipes"),
        filterFields: [
          ...FilterFieldConstants.getSpatialFilterKeys(),
          "implementerType",
          "maintainedBy",
          "landOwnership",
          "pipeType",
          "serviceType",
          "phase",
          "accessible",
          "condition",
          "consequenceOfFailure",
          "correctiveAction",
          "enforcementLevel",
          "linedAssetsShapes",
          "diameterRange",
          "lengthRange",
          "widthRange",
          "lined",
          "routineDate",
          "repairDate",
          "installDate",
        ],
      },
      activities: {
        name: "Activities",
        defaultLayers: ["activities"],
        isGisDataView: true,
        searchByPropertyEnabled: true,
        searchPlaceholder: "Search activity name or address",
        actionButtons: [
          {
            offline: false,
            buttonText: "Add New Activity",
            dataAction: "add-new",
            permissionKey: "can_create_activity",
          },
        ],
        filterBarDisabledButtons: [],
        topLevelDataSort: null,
        flatDataSort: "activities",
        dataSortByTab: { data: ["activities"] },
        filterModule: ActivityFilters,
        filterFields: [
          Progeny.activeHasProgeny() ? "subGroups" : "drainsToRw",
          "audienceType",
          "outreachType",
          "activityGroup",
          "activity",
          "permits",
          "date",
          "activityAudience",
          "activityStaff",
          "activityPollutant",
          "activityBehavior",
          "attendeeCount",
          "impressionCount",
          "volunteerCount",
        ],
        defaultTab: "data",
        listEnabledTabs: ["data", "insight"],
        mapEnabledTabs: [],
        tabFeatureFlags: { insight: "peo-insights-trends" },
        showActionButtonsTabs: ["data"],
        reportingDataGroup: "peo",
        defaultDataSort: "activities",
        hideMapListToggle: { data: true },
        exportsEnabled: ["excel"],
        defaultExportType: "excel",
      },

      // ESG
      properties: {
        name: "Properties",
        defaultDataSort: "rank",
        flatDataSort: "rank",
        get defaultLayers() {
          return [PageController.getConfig()?.layer?.name];
        },
        afterOpenInventory: OtherPropertiesLayer.show,
        afterCloseInventory: OtherPropertiesLayer.reset,
        defaultTab: "data",
        mapEnabledTabs: ["data"],
        dataSortByTab: { data: ["rank", "propertyName", "propertyIdentifier"] },
        searchPlaceholder: "Search by ID, name, or address",
        actionButtons: [],
        isGisDataView: true,
      },
      "incentive-programs": {
        name: "Incentive Programs",
        defaultDataSort: "programName",
        flatDataSort: "programName",
        defaultLayers: ["incentivePrograms"],
        defaultTab: "data",
        mapEnabledTabs: [],
        dataSortByTab: { data: ["programName"] },
        searchPlaceholder: "Search by Program Name",
        actionButtons: [],
        isGisDataView: true,
      },
    };
  };

  return { get };
};

module.exports = DataViewConfig();

const Session = require("../login/session");
const UserPermissions = require("../login/userPermissions");
const Tree = require("../tree");
const ToolSettings = require("../settings/toolSettings");
